// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iframe-fit[data-v-22f70c6f]{width:100%;height:calc(100vh - 51px);border:none}", ""]);
// Exports
module.exports = exports;
